import { Crosshair } from '@phosphor-icons/react';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';

type RecenterButtonProps = {
  onClick: () => void;
};

const BASE_CLASSES =
  'absolute z-40 flex flex-row items-center justify-center rounded-[4px] border-[1px] border-[#1D213B] bg-white text-[#1D213B] shadow-lg hover:cursor-pointer hover:bg-gray-100';

// On phones the map header (search + category chips) occupies the top 140px,
// so the control sits just below it. Icon-only there to leave the middle of
// the row clear for "Search this area".
const MOBILE_CLASSES = 'right-4 top-[150px] p-2';
const DEFAULT_CLASSES = 'bottom-6 left-6 space-x-2 px-3 py-2';

export default function RecenterButton({ onClick }: RecenterButtonProps) {
  const { screenView } = useScreenView();
  const isMobile = screenView === 'mobile';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Recenter on my location"
      title="Recenter on my location"
      className={`${BASE_CLASSES} ${isMobile ? MOBILE_CLASSES : DEFAULT_CLASSES}`}
    >
      <Crosshair size={isMobile ? 20 : 16} />
      {!isMobile && (
        <span className="whitespace-nowrap text-sm font-medium">
          My location
        </span>
      )}
    </button>
  );
}
